export const generateExistingAnalysisDialogString = (sampleId: string, location: string | undefined, deviceType: string): string => {
  return `Det finns redan en godkänd analys med provID ${sampleId} i ${location} för ${deviceType}. Vill du godkänna ändå?`
}